// extracted by mini-css-extract-plugin
export default {"card":"TradingPrevMonthsWidget_card__ycIBU","datepicker":"TradingPrevMonthsWidget_datepicker__vuL34","chartArea":"TradingPrevMonthsWidget_chartArea__nuTg8"};